import { useState } from 'react';
import { GenericTable } from './GenericTable';
import { AddWorkoutInfoDialog } from '../../components/AddWorkoutInfoDialog';
import { workoutsColumns } from '../../constants/tableRows';
import { useWorkoutInfoByIdQuery } from '../../query/useWorkoutInfoByIdQuery';
import { useToastContext } from '../UI/ToastManager';
import { useConstantsQuery } from '../../query/useConstantsQuery';

type RowData = Record<string, React.ReactNode>;

export function WorkoutsTable({ onAdd, data }: { onAdd: () => void, data: RowData[] }) {
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [selectedWorkoutInfoId, setSelectedWorkoutInfoId] = useState<string | null>(null);
  const [dialogMode, setDialogMode] = useState<'add' | 'edit'>('add');
  const { showInfo } = useToastContext();

  const { data: workoutInfoData, isLoading: isLoadingExercise } = useWorkoutInfoByIdQuery(selectedWorkoutInfoId);
  const { data: constantsData, isLoading: isLoadingConstants } = useConstantsQuery();

  const handleAddClick = () => {
    setSelectedWorkoutInfoId(null);
    setDialogMode('add');
    setDialogOpen(true);
  };

  const handleEditClick = (row: RowData) => {
    console.log('Edit button clicked, row data:', row);
    const workoutInfoId = row.id as string;
    console.log('WorkoutInfo ID:', workoutInfoId);
    if (!workoutInfoId) {
      showInfo('Error', 'WorkoutInfo ID not found');
      return;
    }
    setSelectedWorkoutInfoId(workoutInfoId);
    setDialogMode('edit');
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
    setSelectedWorkoutInfoId(null);
  };

  return (
    <>
      <GenericTable 
        columns={workoutsColumns} 
        data={data}
        title='Workout Info' 
        onAdd={handleAddClick}
        onEdit={handleEditClick}
      />
      <AddWorkoutInfoDialog 
        open={isDialogOpen} 
        onOpenChange={handleDialogClose}
        workoutInfo={workoutInfoData || null}
        constantsData={constantsData as any}
        mode={dialogMode}
      />
    </>
  );
}